<ng-template #loading>
    <app-loading></app-loading>
</ng-template>


<span *ngIf="newProduct$ | async as newProduct; else loading">
    <app-product-editor [new]="true" [product]="newProduct" (productSaved)="createProduct($event)"></app-product-editor>
</span>